import script from "./Teams.vue?vue&type=script&setup=true&lang=js"
export * from "./Teams.vue?vue&type=script&setup=true&lang=js"

import "./Teams.vue?vue&type=style&index=0&id=ff5b7cb4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff5b7cb4"]])

export default __exports__